import { useMap } from '@vis.gl/react-google-maps';

import BaseLocationButton from '../LocationButton';

interface Props {
    center: LatLng;
}

function LocationButton({ center }:Props) {
    const map = useMap('google-map');
    return (
        <BaseLocationButton onClick={() => map?.setCenter(center)}/>
    );
}

export default LocationButton;
